import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';


export enum CollaborativeAgreementStatus {
  awaitingSignature = 'awaiting_signature',
  awaitingCounterSignature = 'awaiting_counter_signature',
  active = 'active',
}

export type CollaborativeAgreementSigned = {
  id: string;
  status: CollaborativeAgreementStatus;
  agreementTemplateId: string;
  content: string;
  collaborativeMatchId: string;
  signedAt: string;
  counterSignedAt: string | null;
  expireAt: string;
  createdAt: string;
  updatedAt: string;
};

export type CollaborativeAgreementUnsigned = {
  agreementTemplateId: string;
  collaborativeMatchId: string;
};


export type CollaborativeAgreementExpiring = {
  agreementTemplateId: string;
  collaborativeMatchId: string;
  expireAt: string;
};


export type CollaborativeAgreementExpired = {
  agreementTemplateId: string;
  collaborativeMatchId: string;
  expiredAt: string;
};


export type SignCollaborativeAgreementParams = {
  agreementTemplateId: string;
  collaborativeMatchId: string;
};


export const signCollaborativeAgreement = (params: SignCollaborativeAgreementParams) => restClient.request<{ data: string }>(
  '/api/v1/collaborative_agreement/sign', {
    method: 'POST',
    data: snakecaseKeys(params),
  }
);


export type CounterSignCollaborativeAgreementParams = {
  signedAgreementId: string;
};


export const counterSignCollaborativeAgreement = (params: CounterSignCollaborativeAgreementParams) => restClient.request<{ data: string }>(
  '/api/v1/collaborative_agreement/counter_sign', {
    method: 'POST',
    data: snakecaseKeys(params),
  }
);
